import React from 'react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';

const SidebarNavItem = ({ icon: Icon, label, collapsed, isOpen, onToggle, children }) => (
  <div>
    <button
      onClick={onToggle}
      className={`
        group flex items-center justify-between w-full rounded-md
        text-sm font-medium
        transition-all duration-150
        ${isOpen ? 'text-text bg-mix/[0.04]' : 'text-text-secondary hover:bg-mix/[0.03] hover:text-text'}
        ${collapsed ? 'justify-center px-2 py-2' : 'px-3 py-2'}
      `}
    >
      <span className="flex items-center gap-2.5">
        <Icon className={`w-4 h-4 flex-shrink-0 transition-colors ${isOpen ? 'text-primary' : 'group-hover:text-text'}`} />
        {!collapsed && <span>{label}</span>}
      </span>
      {!collapsed && (
        <span className={`transition-transform duration-200 ${isOpen ? 'text-text-secondary rotate-0' : 'text-text-muted'}`}>
          {isOpen ? <FiChevronDown size={14} /> : <FiChevronRight size={14} />}
        </span>
      )}
    </button>
    {isOpen && !collapsed && (
      <div className="ml-4 pl-3 mt-1 mb-1 space-y-0.5 border-l border-mix/[0.06]">
        {children}
      </div>
    )}
  </div>
);

export default SidebarNavItem;
